import { MessageFormatEnum, MessageRoleEnum } from "schema"

export const KindMap = {
  [MessageFormatEnum.Audio]: "audio",
  [MessageFormatEnum.Image]: "image",
  [MessageFormatEnum.Video]: "video",
  [MessageFormatEnum.Text]: "text",
  [MessageFormatEnum.Document]: "document",
  [MessageFormatEnum.Unsupported]: "text",
} as const

export const RoleMap = {
  [MessageRoleEnum.Assistant]: "assistant",
  [MessageRoleEnum.User]: "user",
} as const
